import { Routes } from "@angular/router";

export const routes: Routes = [
  // Department groups (see core/routing/route-data.ts). Old paths below stay until legacy redirects replace them.
  {
    // Permanent links for labels, QR codes and emails (core/routing/permalinks.ts).
    path: "l",
    loadChildren: () => import("./routes/permalink.routes"),
  },
  {
    path: "dashboards",
    loadChildren: () => import("./routes/dashboards.routes"),
  },
  {
    path: "map",
    loadChildren: () => import("./routes/map.routes"),
  },
  {
    path: "sales",
    loadChildren: () => import("./routes/sales.routes"),
  },
  {
    path: "engineering",
    loadChildren: () => import("./routes/engineering.routes"),
  },
  {
    path: "operations",
    loadChildren: () => import("./routes/operations.routes"),
  },
  {
    path: "quality",
    loadChildren: () => import("./routes/quality.routes"),
  },
  {
    path: "purchasing",
    loadChildren: () => import("./routes/purchasing.routes"),
  },
  {
    path: "billing",
    loadChildren: () => import("./routes/billing.routes"),
  },
  {
    path: "admin",
    loadChildren: () => import("./routes/admin.routes"),
  },
  {
    path: "dev",
    loadChildren: () => import("./routes/dev.routes"),
  },

  {
    path: "about",
    loadChildren: () => import("./feature/about/about.routes"),
  },

  {
    path: "assembly",
    loadChildren: () => import("./feature/assembly/assembly.routes"),
  },
  {
    path: "assembler",
    loadChildren: () => import("./feature/assembler/assembler.routes"),
  },
  {
    path: "auth",
    loadChildren: () => import("@dis/auth").then((m) => m.authRoutes),
  },

  {
    path: "bha-sections",
    loadChildren: () => import("./feature/bha-sections/bha-sections.routes"),
  },

  {
    path: "builds",
    loadChildren: () => import("./feature/builds/builds.routes"),
  },
  {
    path: "collections",
    loadChildren: () => import("./feature/dashboards/collection-detail/routes/collection-detail.routes"),
  },
  {
    path: "components",
    loadChildren: () => import("./feature/components/components.routes"),
  },

  {
    path: "connections",
    loadChildren: () => import("./feature/connections/connection.routes"),
  },

  {
    path: "containers",
    loadChildren: () => import("./containers/containers.routes"),
  },

  {
    path: "customers",
    loadChildren: () => import("./feature/customers/customers.routes"),
  },

  {
    path: "dashboard/customer-kpi",
    loadChildren: () => import("./feature/dashboards/customer-kpi/customer-kpi.routes"),
  },

  {
    path: "dashboard/in-house-testing-jobs",
    loadChildren: () => import("./feature/dashboards/in-house-testing-jobs/in-house-testing-jobs.routes"),
  },

  {
    path: "dashboard/jobs-by-status",
    loadChildren: () => import("./feature/dashboards/jobs-by-status/jobs-by-status.routes"),
  },

  {
    path: "dashboard/jobs-gantt",
    loadChildren: () => import("projects/jtms-front-end/src/app/dashboards/jobs-gantt-charts/jobs-gantt-charts.routes"),
  },

  {
    path: "dashboard/meeting-mode",
    loadChildren: () => import("./feature/dashboards/meeting-mode/meeting-mode.routes"),
  },

  {
    path: "dashboard/operations-timeline",
    loadChildren: () => import("./feature/dashboards/operations-timeline/operations-timeline.routes"),
  },

  {
    path: "dashboard/staged-tools",
    loadChildren: () => import("./feature/dashboards/staged-tools/staged-tools.routes"),
  },

  {
    path: "dashboard/tool-run-counts",
    loadChildren: () => import("./feature/dashboards/tool-run-counts/tool-run-counts.routes"),
  },

  {
    path: "dashboard/operation-status-dashboard",
    loadChildren: () => import("./feature/dashboards/shipment-by-status/shipment-by-status.routes"),
  },

  {
    path: "dataconnect",
    loadChildren: () => import("./feature/dataconnect/dataconnect.routes"),
  },

  {
    path: "home",
    loadChildren: () => import("./feature/home/home.routes"),
  },

  {
    path: "inventory",
    loadChildren: () => import("./feature/shop/inventory/inventory.routes"),
  },

  {
    path: "jobs",
    loadChildren: () => import("./feature/jobs/jobs.routes"),
  },
  {
    path: "leads",
    loadChildren: () => import("./feature/projects/leads/leads.routes"),
  },
  {
    path: "office",
    loadChildren: () => import("./feature/office/office.routes"),
  },

  {
    path: "parts",
    loadChildren: () => import("projects/jtms-front-end/src/app/jtms/6_parts/6-parts.routes"),
  },

  {
    // Group routes first; falls through to the legacy jtms/1_projects routes.
    path: "projects",
    loadChildren: () => import("./routes/projects.routes"),
  },

  {
    path: "quotes",
    loadChildren: () => import("./feature/quotes/quotes.routes"),
  },

  {
    path: "rigs",
    loadChildren: () => import("./feature/rigs/rigs.routes"),
  },

  {
    path: "settings",
    loadChildren: () => import("./feature/settings/settings.routes"),
  },

  {
    // Group routes first; falls through to the legacy feature/shop routes.
    path: "shop",
    loadChildren: () => import("./routes/shop.routes"),
  },

  {
    path: "tables",
    loadChildren: () => import("./feature/tables/tables.routes"),
  },

  {
    path: "testing",
    loadChildren: () => import("./testing/testing.routes"),
  },

  {
    path: "tool-families",
    loadChildren: () => import("./feature/tool-families/tool-families.routes"),
  },

  {
    path: "tool-grid-editable",
    loadChildren: () => import("./feature/tool-grid-editable/tool-grid-editable.routes"),
  },

  {
    path: "users",
    loadChildren: () => import("./feature/users/users.routes"),
  },

  {
    path: "wallboard",
    loadChildren: () => import("./feature/wallboard/wallboard.routes"),
  },

  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },

  {
    path: "**",
    loadChildren: () => import("./feature/page-not-found/page-not-found.routes"),
  },
];
